<template>
  <section class="content">
    <div id="overlay"  v-if="loading">
    <div class="spinner"></div>
    <br/>
      <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <!-- <Toast style="margin-top: 35px" /> -->
        <form class="form-horizontal">
           <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-2">
          <label for="accountUpload">Inventory Auto Adjust </label>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="accountUpload">Store </label>
        </div>
        <div class="p-field p-col-12 p-md-2">
              <!-- <label for="toDate">Store</label> -->
              <Dropdown
                v-if="!setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :showClear="true"
              />
              <Dropdown
                v-if="setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :disabled="true"
              />
            </div>
        <div class="p-field p-col-12 p-md-2">
          <Button class="p-button-raised p-button-rounded" label="Adjust Item Stock" @click.prevent="inventoryAutoAdjustment"></Button>
        </div>

      </div>
       <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-2">
          <label for="accountUpload">Account Auto Adjustment </label>
          
        </div>
        <div class="p-field p-col-12 p-md-2">
          <Button class="p-button-raised p-button-rounded" label="Adjust Account" @click.prevent="accountAutoAdjustment"></Button>
        </div>
       </div>

        </form>
      </div>
  </section>
</template>
<script>
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
export default {
  name: 'autoSettlement',
  data() {
    return {
      message: '',
      show: false,
      messageType: '',
      showDialog: false,
      loading: false,
      status: 'ACTIVE',
      warehouseId: ''
    }
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  mounted() {
    this.warehouseList()
    this.setWarehouse()
  },
  methods: {
    async accountAutoAdjustment() {
      this.loading = true
      let response = await this.$store.dispatch('loadAutoAdjustmentAccount')
      this.loading = false
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async inventoryAutoAdjustment() {
      if (this.warehouseId !== '' && this.warehouseId !== null) {
        this.id = this.warehouseId.id
      } else {
        this.id = '0'
      }
      let dat = {
        warehouse: this.id
      }
      this.loading = true
      let response = await this.$store.dispatch('loadAutoAdjustmentInventory', dat)
      this.loading = false
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      }
    },
    responseMessage(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.cancel()
      } else if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!', life: 10000})
      }
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    }
  },
  components: {
    Button,
    Dropdown
    // Toast
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">

</style>



// WEBPACK FOOTER //
// autoSettelTransaction.vue?d906c4d4